import { render } from "./NotFound.vue?vue&type=template&id=be5ea802&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=be5ea802&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be5ea802"

export default script